export default "/_next/static/images/55b8f77cb5c155b2906f557d470068c2.png";